import styled from 'styled-components';

import { RouterLink } from '@redux-first-router-link';

export const FooterButton = styled(RouterLink)`
  position: absolute;
  bottom: ${({ theme }) => theme.x2spacePx}px;
  left: 50%;
  transform: translateX(-50%);

  background: ${({ theme }) => theme.color.brand01};
  text-decoration: none;
  padding: 5px ${({ theme }) => theme.x2spacePx}px;
  border-radius: 9999px;
`;
